import { Skeleton } from '@/components/ui/skeleton'
import React from 'react'

const DetailsPageSkeleton = () => {
  return (
    <div className="flex gap-4">
      <Skeleton className="h-[306px] w-[409px] rounded-xl mobile-width" />
      <div className="flex flex-col gap-6 mobile-width">
        <div className="flex flex-col gap-1 mobile-width">
          <Skeleton className="w-60 h-5" />
          <Skeleton className="w-80 h-5" />
        </div>
        <Skeleton className="w-20 h-5 -mt-3 rounded-full mobile-width" />
        <div className="flex flex-col gap-1 mobile-width">
          <Skeleton className="w-40 h-5" />
          <Skeleton className="w-20 h-5" />
        </div>
        <div className="flex flex-col gap-1 mobile-width">
          <Skeleton className="w-40 h-5" />
          <Skeleton className="w-20 h-5" />
        </div>
        <div className="flex flex-col gap-1 mobile-width">
          <Skeleton className="w-20 h-5" />
          <div className="flex gap-3 mobile-width">
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
            <Skeleton className="w-7 h-7" />
          </div>
        </div>
        <div className="shadow-[0_0_4px_0_rgba(0,0,0,0.16)] p-4 py-2 flex gap-4 mt-2 mobile-width">
          <Skeleton className="w-10 h-10" />
          <div className="flex flex-col gap-1 mobile-width">
            <Skeleton className="w-40 h-4" />
            <Skeleton className="w-40 h-4" />
          </div>
        </div>
        <div className="shadow-[0_0_4px_0_rgba(0,0,0,0.16)] p-4 py-2 flex gap-4 mt-2 mobile-width">
          <Skeleton className="w-10 h-10" />
          <div className="flex flex-col gap-1 mobile-width">
            <Skeleton className="w-40 h-4" />
            <Skeleton className="w-40 h-4" />
          </div>
        </div>
        <Skeleton className="w-40 h-10" />
        <div className="flex flex-col gap-1 mobile-width">
          <Skeleton className="w-40 h-5" />
          <Skeleton className="w-20 h-5" />
        </div>
      </div>
    </div>
  )
}

export default DetailsPageSkeleton
